import {Component, inject} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'admin-onboarding-payment-error',
  templateUrl: './admin-onboarding-payment-error.page.html',
  styleUrls: ['./admin-onboarding-payment-error.page.scss']
})
export class AdminOnboardingPaymentErrorPage {
  readonly #router = inject(Router);
  readonly #activatedRoute = inject(ActivatedRoute);

  leave() {
    this.#router.navigate(["/app"])
  }

  retry() {
    this.#router.navigate(["../subscription"], {relativeTo: this.#activatedRoute})
  }

}
